<template>
  <div class="place-order">
    <div class="bg-white text-center py-3 shadow border-bottom">
      <router-link to="">
        <logo height="60" />
      </router-link>
    </div>
    <div class="container mt-3" v-if="!loading">
      <router-link :to="{ name: 'home' }" class="btn btn-primary"
        ><i class="fal fa-arrow-left"></i>Go To Dashboard</router-link
      >
      <div class="row mt-3">
        <div class="col-9">
          <div class="card">
            <div class="card-body">
              <h4>Order Content</h4>
              <hr />
              <form @submit.prevent="submit">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="mb-2">Content Type</label>
                    <vue-select
                      label="name"
                      placeholder="Select Type"
                      :options="types"
                      v-model="order.type"
                    />
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="mb-2">Content Category</label>
                    <vue-select
                      label="name"
                      placeholder="Select Category"
                      :options="categories"
                      v-model="order.category"
                    />
                  </div>
                  <div class="col-md-12 mb-3">
                    <label class="mb-2">Content Title</label>
                    <input
                      type="text"
                      placeholder="Content Title"
                      class="form-control"
                      v-model="order.title"
                    />
                    <span class="input-error" v-if="has_errors && order.title.length < 1">The title is required</span>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label class="mb-2">Content Instructions</label>
                    <textarea
                      placeholder="Content Instructions"
                      rows="5"
                      class="form-control"
                      v-model="order.instructions"
                    ></textarea>
                    <span class="input-error" v-if="has_errors && order.instructions.length < 1">The instructions is required</span>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label class="mb-2 w-100">
                      <span>Content Examples</span>
                      <small class="text-muted">(If any)</small>
                      <a href="#" class="float-end" @click.prevent="order.examples.push('')"><i class="fa fa-plus me-0"></i></a>
                    </label>
                    <div class="row">
                      <div class="col-md-6" v-for="(example, i) in order.examples" :key="`example-${i}`">
                        <div class="input-group password-input mb-2">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Example URL"
                            v-model="order.examples[i]"
                          />
                          <button class="btn" @click.prevent="order.examples.splice(i, 1)">
                            <i class="fal me-0 fa-trash"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <hr>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label class="mb-2">Content Quality</label>
                    <div class="border p-2">
                      <div class="d-flex">
                        <div
                          class="centered"
                          style="width: 120px; justify-content: start"
                        >
                          <input-quality
                            :type="order.type"
                            v-model="order.quality"
                          />
                        </div>
                        <div style="width: calc(100% - 120px)">
                          <h5>
                            {{ order.quality.name }} ($ {{ price_per_word }} per
                            word)
                          </h5>
                          <p>
                            {{ order.quality.description }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label class="mb-2">Content Word Count</label>
                    <div class="row">
                      <div class="col-md-6">
                        <label class="mb-2">Min</label>
                        <input
                          type="number"
                          placeholder="Min"
                          class="form-control"
                          min="1"
                          v-model="order.min"
                        />
                        <span v-if="order.min > order.max" class="input-error"
                          >Min word count cannot be greater than max word
                          count</span
                        >
                      </div>
                      <div class="col-md-6">
                        <label class="mb-2">Max</label>
                        <input
                          type="number"
                          placeholder="Max"
                          class="form-control"
                          min="2"
                          v-model="order.max"
                        />
                        <span v-if="order.max == ''" class="input-error"
                          >Max word count cannot be empty</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card sticky-top" style="top: 15px">
            <div class="card-body">
              <h4><i class="far fa-shopping-cart"></i> My Order</h4>
              <hr />
              <div>
                <p class="mb-0">
                  <strong class="me-2">Quality:</strong>
                  <quality :quality="order.quality" />
                </p>
                <p>{{ order.quality.name }}</p>
              </div>
              <div>
                <p class="mb-0">
                  <strong class="me-2">Word Count:</strong>
                </p>
                <p>Min: {{ order.min }}, Max: {{ order.max }}</p>
              </div>
              <div>
                <p class="mb-0">
                  <strong class="me-2">Estimated Delivery:</strong>
                </p>
                <p>{{ hours }} Hours</p>
              </div>
              <hr />
              <div>
                <h3>Total: ${{ total }}</h3>
              </div>
              <hr />
              <div>
                <button class="btn btn-primary w-100" @click.prevent="submit">
                  Proceed<i class="fal fa-arrow-right ms-3"></i>
                </button>
              </div>
              <div class="mt-4">
                <api-image src="defaults/payments.png" class="w-100" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loading v-if="loading" />

    <footer class="footer bg-white">
      <div class="container-fluid">
        <div class="row text-muted">
          <div class="col-8 text-start">
            <ul class="list-inline">
              <li class="list-inline-item">
                <a class="text-muted" href="#">Support</a>
              </li>
              <li class="list-inline-item">
                <a class="text-muted" href="#">Privacy</a>
              </li>
              <li class="list-inline-item">
                <a class="text-muted" href="#">Terms of Service</a>
              </li>
              <li class="list-inline-item">
                <a class="text-muted" href="#">Contact</a>
              </li>
            </ul>
          </div>
          <div class="col-4 text-end">
            <p class="mb-0">
              &copy; 2024 -
              <a class="text-muted" href="#">SEOVINES</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  mounted() {
    if (!this.$storage.has("token")) {
      return this.$router.push({ name: "login" });
    }

    this.fetch();
  },

  data() {
    return {
      categories: [],
      types: [],
      loading: true,
      order: { quality: {}, min: 100, max: 100, examples: ['', ''], title: '', instructions: '' },
      has_errors: false
    };
  },

  methods: {
    fetch() {
      this.loading = true;

      this.$axios.get("/api/v1/place-order").then((response) => {
        this.categories = response.data.categories;
        this.types = response.data.types;
        this.order.type = response.data.types[0];
        this.order.category = response.data.categories[0];
        this.loading = false;
      });
    },

    submit() {
      if(this.validate()) {
        this.proceed()
      }
    },

    validate() {
      this.has_errors = false

      if(this.order.title.length < 1) {
        this.has_errors = true
      }

      if(this.order.instructions.length < 1) {
        this.has_errors = true
      }

      if(this.order.max < 1) {
        this.has_errors = true
      }

      if(this.order.min > this.order.max) {
        this.has_errors = true
      }

      return ! this.has_errors
    },

    proceed() {
      this.$storage.set('order', JSON.stringify(this.order))
      this.$router.push({ name: 'pay-order' })
    }
  },

  computed: {
    price_per_word() {
      return this.order.quality.price / this.order.quality.words;
    },

    total() {
      return Math.round(this.price_per_word * this.order.max, 2);
    },

    hours() {
      return Math.round((this.order.quality.hours / this.order.quality.words) * this.order.max, 2)
    }
  },
};
</script>
